// Vendor imports
const classNames = require('classnames')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const LazyImage = require('client-v2/common/components/lazy-image')
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('CollectionEditModalImagePreview')

function CollectionEditModalImagePreview({
  className,
  label,
  value,
  onClick
}) {
  return (
    tag('div', {
      className: classNames(
        className,
        bem.block()
      )
    },
      tag(LazyImage, {
        className: bem.element('image'),
        sources: [ value ]
      }),
      tag('div', {
        className: bem.element('label'),
        onClick
      },
        tag('div', {
          className: bem.element('icon')
        }),
        tag('div', {
          className: bem.element('text')
        },
          label
        )
      )
    )
  )
}

module.exports = CollectionEditModalImagePreview
